import { render, staticRenderFns } from "./PkgPlanForm.vue?vue&type=template&id=bbe8bda0&"
import script from "./PkgPlanForm.vue?vue&type=script&lang=js&"
export * from "./PkgPlanForm.vue?vue&type=script&lang=js&"
import style0 from "./PkgPlanForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgPlanForm.vue"
export default component.exports